import { useContext, useRef, useCallback } from 'react';
import { fetcher } from 'services';
import { parse } from 'query-string';
import LoggingContext from 'contexts/LoggingContext';
import { callGAEvent } from 'utils/GAUtils';

const useLogging = () => {
  const logging = useContext(LoggingContext);
  const loggingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastLoggingUriRef = useRef<string>('');

  const postLogging = useCallback(() => {
    const reqUri = window.location.href;

    // 중복 로깅 방지
    if (logging.lastLoggingPage === reqUri || lastLoggingUriRef.current === reqUri) {
      return;
    }

    const lastPage = logging.lastLoggingPage;
    lastLoggingUriRef.current = reqUri;

    // 디바운싱 적용 (500ms)
    if (loggingTimeoutRef.current) {
      clearTimeout(loggingTimeoutRef.current);
    }

    loggingTimeoutRef.current = setTimeout(() => {
      logging.setLastLoggingPage(reqUri);
      callGAEvent();

      const tfrom = parse(location.search).tfrom as string;
      callLogging(reqUri, lastPage ? lastPage : '', tfrom);
    }, 500);
  }, [logging]);

  const shareLogging = useCallback(() => {
    callLogging(window.location.href + '/contentshare', window.location.href);
  }, []);

  const downloadLogging = useCallback(() => {
    callLogging(window.location.href + '/contentdownload', window.location.href);
  }, []);

  const callLogging = useCallback((reqUri: string, preUri: string, tfrom?: string) => {
    fetcher.common
      .postLogging({
        reqUri,
        preUri,
        tfrom,
      })
      .then(res => {})
      .catch(err => {
        console.warn('Logging API call failed:', err);
      });
  }, []);

  return {
    postLogging,
    shareLogging,
    downloadLogging,
  };
};

export default useLogging;
